export const API_ROOT =
  process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:5000' : '';

export const MIXPANEL_KEY = "05822e9dadcdca6fdf3c42405905bb0e";